import { SortIcon } from "../../images";
import { Order } from "../../../types";
import { Stack } from "@mui/material";
import { EllipsisTooltip } from "../../ui/CustomTooltip";
import { TextWrapper } from "./TextWrapper";

export const SortCell = ({
  id,
  value,
  tooltip,
  isSelected,
  order,
  clickHandler,
  minWidth,
  maxWidth,
  justifyContent = "flex-end",
  gap = "8px",
  isFirstColumn,
  style,
}: {
  id: string;
  value: string;
  tooltip?: string;
  isSelected: boolean;
  order?: string;
  clickHandler: (key: string) => void;
  minWidth: string;
  maxWidth: string;
  justifyContent?: "space-between" | "center" | "flex-start" | "flex-end";
  gap?: string;
  isFirstColumn?: boolean;
  style?: React.CSSProperties;
}) => {
  return (
    <Stack
      onClick={() => clickHandler(id)}
      flexDirection="row"
      alignItems="center"
      minWidth={minWidth}
      maxWidth={maxWidth}
      justifyContent={justifyContent}
      width="100%"
      gap={gap}
      padding="0 16px"
      sx={{
        cursor: "pointer",
        ...(!isFirstColumn && {
          "&:hover": {
            opacity: 0.8,
          },
        }),
        ...(isFirstColumn && {
          backgroundColor: "#E1E6EF",
          borderTopLeftRadius: "20px",
        }),
      }}
      style={style}
    >
      {value && (
        <EllipsisTooltip tooltip={tooltip} align="center">
          <TextWrapper isHighlighted={true} text={value} />
        </EllipsisTooltip>
      )}

      <SortIcon
        rotate={isSelected && order === Order.ASC ? "180" : "0"}
        style={{
          opacity: isSelected ? 1 : 0.5,
        }}
      />
    </Stack>
  );
};
